// Zinsdelen voor de samenvatting van een herhaling (Duits). Zelfde vorm als recurrenceApp.nl.ts.
// Rangtelwoorden in de datief ("am letzten Freitag").
export const appRecurrenceDe = {
    once: 'Einmalig',
    everyDay: 'Jeden Tag',
    everyWorkday: 'Jeden Werktag',
    everyWeek: 'Jede Woche',
    everyMonth: 'Jeden Monat',
    everyYear: 'Jedes Jahr',
    everyWeekdays: 'Jeden {days}',
    otherDay: 'Jeden zweiten Tag',
    otherWeek: 'Jede zweite Woche',
    otherMonth: 'Jeden zweiten Monat',
    otherYear: 'Jedes zweite Jahr',
    nDays: { one: 'Alle {count} Tage', other: 'Alle {count} Tage' },
    nWeeks: { one: 'Alle {count} Wochen', other: 'Alle {count} Wochen' },
    nMonths: { one: 'Alle {count} Monate', other: 'Alle {count} Monate' },
    nYears: { one: 'Alle {count} Jahre', other: 'Alle {count} Jahre' },
    dailyOnlyOn: '{period}, nur am {days}',
    weeklyOn: '{period} am {days}',
    weeklyAllDays: '{period} an allen Tagen',
    weeklyWorkdays: '{period} an Werktagen',
    monthlyOrdinal: 'Jeden Monat am {ordinals}',
    monthlyOrdinalPeriod: '{period} am {ordinals}',
    monthlyOn: '{period} am {days}',
    ifWeekday: '{text}, wenn das ein {days} ist',
    monthDay: '{day}.',
    lastDay: 'letzten Tag',
    nthLastDay: '{ordinal} Tag',
    yearlyOrdinal: '{period} am {ordinals} im {months}',
    yearlyOn: '{period} am {date}',
    yearlyDays: '{period} am {days} im {months}',
    dayMonth: '{day}. {month}',
    ordinalWeekday: '{ordinals} {weekday}',
    anyWeekday: 'jeden {weekday}',
    ord1: 'ersten',
    ord2: 'zweiten',
    ord3: 'dritten',
    ord4: 'vierten',
    ord5: 'fünften',
    ordLast: 'letzten',
    ordLast2: 'vorletzten',
    ordLast3: 'drittletzten',
    ordLast4: 'viertletzten',
    ordLast5: 'fünftletzten',
    ordN: '{n}.',
    evenWeeks: '{text} in geraden Wochen',
    oddWeeks: '{text} in ungeraden Wochen',
    at: '{text} um {time}',
    fromTo: '{text} von {start} bis {end}',
    times: { one: '{text}, einmal', other: '{text}, {count}-mal' },
    until: '{text}, bis {date}',
    listAnd: '{a} und {b}',
    listSep: ', ',
};
//# sourceMappingURL=recurrenceApp.de.js.map